import { useCallback } from 'react';

import { IGlobalProductEntity } from 'components/BusinessToolForm/Sections/Global/general/products';

import { ICalculatedValuesWithProductId } from './types';

export const useOrderTableValues = () => {
  const orderValues = useCallback((reference: IGlobalProductEntity[], toOrder: ICalculatedValuesWithProductId[]) => {
    return reference.map((ref) => {
      return toOrder.find((calculatedValue) => calculatedValue.productId === ref.productId);
    });
  }, []);

  return orderValues;
};
